<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <header class="text-center pb-4 border-b border-grey">
      <h3
        class="my-0 font-bold"
        v-text="'Move Document:'"
      />
    </header>
    <div class="mt-4">
      <Multiselect
        id="move-document-target-folder"
        v-model="targetFolder"
        :options="existingFolders"
        label="title"
        track-by="uuid"
        placeholder="Select folder"
        open-direction="bottom"
        :allow-empty="false"
      >
        <template
          slot="option"
          slot-scope="props"
        >
          <div class="option__desc">
            <span
              class="option__title"
              :class="calculateClass(props.option.level)"
              v-text="props.option.title"
            />
          </div>
        </template>
      </Multiselect>
    </div>
    <div class="flex justify-center items-baseline modal-footer text-center mt-4">
      <button
        type="button"
        class="btn"
        @click="save"
        v-text="'Save'"
      />
      <a
        href="#"
        class="mx-4"
        @click.prevent="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
import Multiselect from 'vue-multiselect'

export default {
  name: 'MoveDocumentModal',
  components: {
    Multiselect,
  },
  data() {
    return {
      targetFolder: {
        uuid: '',
      },
    }
  },
  computed: {
    show() {
      return this.$store.state.document.moveDocumentModal.open
    },
    document() {
      return this.$store.state.document.moveDocumentModal.document
    },
    existingFolders() {
      return this.$store.getters.flatFolderTree
    },
  },
  watch: {
    show() {
      if (this.show) {
        if (!this.$store.state.document.folders.data.length) {
          this.$store.dispatch('documentGetFolderTree')
        }
      }
    },
  },
  methods: {
    calculateClass(level) {
      const margin = {
        1: 'ml-2',
        2: 'ml-4',
        3: 'ml-6',
        4: 'ml-8',
      }

      return level > 1 ? `text-grey-darker ${margin[level]}` : ''
    },
    save() {
      this.$api
        .active()
        .put(`documents/${this.document.uuid}/move`, {
          folderUuid: this.targetFolder.uuid,
        })
        .then(() => {
          this.$store.commit('baseAddNotification', {
            type: 'success',
            title: 'Success',
            text: 'Document moved successfully!',
          })

          this.$store.dispatch(
            'documentGetFolderDetails',
            this.document.attributes.folder_uuid
          )

          this.close()
        })
    },
    close() {
      this.$store.commit('documentCloseMoveDocumentModal')
    },
  },
}
</script>
